import React, { useState } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css"; 
import { useTranslation } from "react-i18next";

const ForgotPasswordModal = ({ show, handleClose }) => {

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [rePassword, setRePassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const { t, i18n } = useTranslation();
  const inputDir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <Modal show={show} onHide={handleClose} centered className="ticket-details-modal-sec mx-500">
      <Modal.Header closeButton>
        <div className="left-details mb-3">
          <h2>{t("setPasswordTitle")}</h2>
          <p>{t("setPasswordMessage")}</p>
        </div>
      </Modal.Header>

      <Modal.Body className="credential-sec">
        <div className="from-box-sec form-sec">
          <Form>
            <div className="position-relative mb-4">
              <FloatingLabel controlId="password"  label={t("password")}>
                <Form.Control 
                  type={showPassword ? "text" : "password"} 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  placeholder={t("password")} 
                  dir={inputDir}
                />
              </FloatingLabel>
              <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`} style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}/>
            </div>

            {/* Confirm Password */}
            <div className="position-relative mb-4">
              <FloatingLabel controlId="confirmPassword" label={t("createPassword")}>
                <Form.Control 
                  type={showConfirmPassword ? "text" : "password"} 
                  value={confirmPassword} 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                  placeholder={t("createPassword")} 
                  dir={inputDir}
                />
              </FloatingLabel>
              <i className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`} style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}/>
            </div>

            {/* Re-enter Password */}
            <div className="position-relative mb-4">
              <FloatingLabel controlId="rePassword" label={t("reEnterPassword")}>
                <Form.Control 
                  type={showRePassword ? "text" : "password"} 
                  value={rePassword} 
                  onChange={(e) => setRePassword(e.target.value)} 
                  placeholder={t("reEnterPassword")} 
                  dir={inputDir}
                />
              </FloatingLabel>
              <i className={`fa ${showRePassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`} style={{ cursor: "pointer" }} onClick={() => setShowRePassword(!showRePassword)}/>
            </div>
          </Form>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end mt-2">
        <Button variant="primary" className="w-100">
        {t("setPasswordBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForgotPasswordModal;
